<button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
    <mat-icon>close</mat-icon>
</button>

<mat-dialog-content class="!max-h-[85vh]">
    <div class="flex flex-col gap-4 items-center justify-center overflow-hidden" [ngSwitch]="fileType">
        <img
            *ngSwitchCase="'img'"
            (error)="onErr()"
            [src]="src"
            [alt]="src"
            class="object-contain h-[75vh] max-w-[85vw]"
        />

        <video
            *ngSwitchCase="'video'"
            controls
            (error)="onErr()"
            class="object-contain h-[75vh] max-w-[85vw]">
            <source [src]="src" />
            Preglednik ne podržava ovaj video format
        </video>

        <p
            class="m-0 flex w-72 max-w-[75vw] flex-col items-center justify-center gap-3 py-2 text-center text-valamardarkgray"
            *ngSwitchDefault>
            <mat-icon class="!flex !h-16 !w-16 items-center justify-center !text-[4rem] !leading-none">
                description
            </mat-icon>
            <span class="leading-5">
                {{ src ? "Datoteka je nepoznatog formata." : "Nije zadana nikakva datoteka." }}
            </span>
        </p>
    </div>
</mat-dialog-content>
